(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-hero-javascript"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  document.querySelectorAll("[data-lp-hero-canvas]").forEach(function (canvas) {
    if (canvas.dataset.lpHeroInit === "true") return;
    canvas.dataset.lpHeroInit = "true";

    var ctx = canvas.getContext("2d");
    if (!ctx) return;

    var w, h, t = 0;
    var rafId = null;
    var isVisible = true;
    var phi = 1.61803398875;
    var waves = [
      { amp: 34, len: 0.01, sp: 0.012, y: 0.34, col: "rgba(77,205,196,.34)", lw: 1.4 },
      { amp: 48, len: 0.007, sp: 0.008, y: 0.5, col: "rgba(240,78,35,.22)", lw: 1.6 },
      { amp: 26, len: 0.014, sp: 0.017, y: 0.62, col: "rgba(77,205,196,.20)", lw: 1.1 },
      { amp: 60, len: 0.005, sp: 0.006, y: 0.72, col: "rgba(255,255,255,.06)", lw: 2 }
    ];

    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = canvas.clientWidth;
      h = canvas.clientHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function draw() {
      if (!isVisible) {
        rafId = null;
        return;
      }

      ctx.clearRect(0, 0, w, h);
      waves.forEach(function (wv, i) {
        ctx.beginPath();
        ctx.lineWidth = wv.lw;
        ctx.strokeStyle = wv.col;
        for (var x = 0; x <= w; x += 6) {
          var m =
            Math.sin(x * wv.len + t * wv.sp) +
            0.4 * Math.sin(x * wv.len * phi + t * wv.sp * phi + i) +
            0.25 * Math.sin((x * wv.len) / phi - t * wv.sp * 1.3);
          var y = h * wv.y + m * wv.amp;
          if (x === 0) ctx.moveTo(x, y);
          else ctx.lineTo(x, y);
        }
        ctx.stroke();
      });
      t += 1;
      rafId = window.requestAnimationFrame(draw);
    }

    function start() {
      if (rafId == null && isVisible) draw();
    }

    function stop() {
      if (rafId != null) {
        window.cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    size();
    window.addEventListener("resize", size);

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            isVisible = entry.isIntersecting;
            if (isVisible) start();
            else stop();
          });
        },
        { root: null, threshold: 0.05 }
      ).observe(canvas);
    }

    start();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-timeline-javascript"] && !Shopify.designMode) return;
  try {
    (function () {
  var tracks = document.querySelectorAll("[data-lp-timeline-track]");
  if (!tracks.length) return;

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  tracks.forEach(function (track) {
    if (track.dataset.lpTimelineInit === "true") return;
    track.dataset.lpTimelineInit = "true";

    if (reducedMotion) {
      track.classList.add("lp-timeline__track--go");
      return;
    }

    if (!("IntersectionObserver" in window)) {
      track.classList.add("lp-timeline__track--go");
      return;
    }

    new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("lp-timeline__track--go");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    ).observe(track);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
